import type { LapRecord } from './replay';

/**
 * Your own lap beside a replay: the fastest of yours that replays here (kept on this device, or your lap on the
 * board), unless it's one of the laps being watched (then it's already on screen). Null: none to show.
 */
export function ownLapFor(
  candidates: readonly (LapRecord | null | undefined)[],
  watched: readonly LapRecord[],
  canReplay: (r: LapRecord) => boolean,
): LapRecord | null {
  const same = (a: LapRecord, b: LapRecord): boolean => a.inputs === b.inputs && a.endTick === b.endTick;
  const mine = candidates.filter((r): r is LapRecord => !!r).sort((a, b) => a.lapMs - b.lapMs);
  for (const r of mine) {
    if (watched.some((w) => same(w, r))) return null;
    if (canReplay(r)) return r;
  }
  return null;
}

/**
 * At the line: your gap to their lap in each sector (+ where yours was slower, − where it was faster), and the
 * sector that made the most of the difference, said as a line for the card.
 */
export function sectorSplit(
  mine: { lapMs: number; sectorMs: readonly number[] },
  theirs: { lapMs: number; sectorMs: readonly number[] },
): { split: number[]; note: string } {
  const split = mine.sectorMs.map((v, k) => v - (theirs.sectorMs[k] ?? v));
  const total = mine.lapMs - theirs.lapMs;
  if (total === 0) return { split, note: 'dead level' };
  const k = split.indexOf(total > 0 ? Math.max(...split) : Math.min(...split));
  return { split, note: `most ${total > 0 ? 'lost' : 'gained'} in sector ${k + 1}` };
}
